export default __webpack_public_path__ + "static/media/arrow-down-dark.532cebab.svg";